import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { AlbumType } from 'types';
import './albums.scss';

const GET_ALBUMS = gql`
  query GET_ALBUMS {
    albums(first: 100, orderBy: releaseDate_DESC) {
      id
      albumUrl
      title
      releaseDate
      albumCover {
        id
        url(transformation: { document: { output: { format: webp } } })
      }
    }
  }
`;

function Albums() {
  const { loading, data } = useQuery(GET_ALBUMS);
  if (loading) return <div />;
  const { albums } = data;

  return (
    <section className="container dark-section">
      <div className="grid justify-content-start align-items-center w-10 mx-auto">
        {albums.map((albumItem: AlbumType) => (
          <Link
            to={`/music/${albumItem.albumUrl}`}
            key={albumItem.albumUrl}
            className="col-10 md:col-4 mb-4 no-underline text-center max-w-max album-item mx-auto md:mx-0 animate-col-width">
            {!!albumItem.albumCover?.url && (
              <img
                src={albumItem.albumCover.url}
                alt={(albumItem.title && albumItem.title) || ''}
                className="w-full mx-auto"
              />
            )}
            {!!albumItem.title && (
              <p className="font-bold mb-1 pb-0">{albumItem.title}</p>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
}

export default Albums;
